import FilterConstants from '../../filter-constants';
import FirstOrderStage from '../stages/first-order';
import { filters } from '../../models/filter/filter';

//TODO: DELETE THIS FILE
export default class {
  getRmsNoise(totalSpectralNoiseRto, frequencyArray, adcBandwidth) {
    // var filter = Filter.create({ selectedFilterType: FilterConstants.filterType.lowPass });
    var stage = FirstOrderStage.create({
      stageQ: Math.sqrt(2) / 2,
      stageFp: adcBandwidth,
      gain: 1,
      stageId: 1,
      filter: filters[FilterConstants.filterType.lowPass],
      frequencyArray: frequencyArray,
    });
    var adcResponseCurve = stage.magnitude;

    /*Filter noise by adc bandwidth curve*/
    var adcFilteredNoise = [];
    for (var i = 0; i < frequencyArray.length; i++) {
      adcFilteredNoise[i] = adcResponseCurve[i] * totalSpectralNoiseRto[i];
    }

    var rmsNoise = 0;
    // Loop through the frequency array until a value is found that's not less than the ADC bandwidth.
    for (i = 1; i < frequencyArray.length; i++) {
      var frequencySpan = frequencyArray[i] - frequencyArray[i - 1];
      var noiseAverage = (adcFilteredNoise[i] + adcFilteredNoise[i - 1]) / 2;
      var noiseRootHz = noiseAverage * Math.sqrt(frequencySpan);

      // Calculate the RMS noise.
      rmsNoise = Math.sqrt(rmsNoise * rmsNoise + noiseRootHz * noiseRootHz);
    }

    return rmsNoise;
  }
  getPeakToPeakNoise(totalSpectralNoiseRto, frequencyArray, adcBandwidth) {
    var rmsNoise = this.getRmsNoise(totalSpectralNoiseRto, frequencyArray, adcBandwidth);
    var result = rmsNoise * 6.6;
    return result;
  }
  getEquivalentNumberOfBitsArray(totalSpectralNoiseRto, frequencyArray, adcBandwidth) {
    var ADC_RANGES = [1, 2, 5, 10];
    var peakToPeakNoise = this.getPeakToPeakNoise(totalSpectralNoiseRto, frequencyArray, adcBandwidth);
    var result = [];
    // Loop through the static list of ADC ranges.
    for (var i = 0; i < ADC_RANGES.length; i++) {
      // Calculate the equivalent number of bits, and associate it with it's ADC input range.
      var equivalentNumberOfBitsObj = {
        adcInputRange: ADC_RANGES[i],
        equivalentNumberOfBits: Math.log(ADC_RANGES[i] / peakToPeakNoise) / Math.log(2),
      };

      // Add the object to the array.
      result.push(equivalentNumberOfBitsObj);
    }

    return result;
  }
}
